import { render, staticRenderFns } from "./ViewReportsModalRelatedTopics.vue?vue&type=template&id=6c348cb4&scoped=true&"
import script from "./ViewReportsModalRelatedTopics.vue?vue&type=script&lang=js&"
export * from "./ViewReportsModalRelatedTopics.vue?vue&type=script&lang=js&"
import style0 from "./ViewReportsModalRelatedTopics.vue?vue&type=style&index=0&id=6c348cb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c348cb4",
  null
  
)

export default component.exports